.custom-swal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99999;
  animation: fadeIn 0.4s ease-out;
}

.custom-swal-modal {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 24px;
  box-shadow: var(--shadow-xl);
  padding: 36px;
  max-width: 520px;
  width: 90%;
  position: relative;
  animation: slideIn 0.4s ease-out;
  border: 2px solid rgba(6, 49, 100, 0.1);
  box-shadow:
    0 25px 80px rgba(6, 49, 100, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.8) inset;
}

.custom-swal-header {
  text-align: center;
  margin-bottom: 28px;
}

.custom-swal-icon {
  width: 72px;
  height: 72px;
  margin: 0 auto 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  position: relative;
}

.custom-swal-icon.warning-icon {
  /* background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%); */
  color: var(--amber);
  /* box-shadow: 
    0 12px 32px rgba(212, 148, 58, 0.25),
    0 0 0 1px rgba(212, 148, 58, 0.1) inset; */
  position: relative;
}

.custom-swal-icon.warning-icon::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  /* background: linear-gradient(135deg, var(--amber), #f39c12); */
  border-radius: 50%;
  z-index: -1;
  opacity: 0.3;
}

.custom-swal-title {
  font-size: 28px;
  font-weight: 700;
  color: #0f2b46;
  margin: 0 0 12px 0;
  font-family: "Poppins", sans-serif;
  letter-spacing: -0.5px;
}

.custom-swal-text {
  font-size: 16px;
  color: #64748b;
  margin: 0;
  line-height: 1.6;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}

.custom-swal-content {
  margin-bottom: 28px;
}

.custom-swal-input {
  display: block;
  width: 100%;
  padding: 16px 20px;
  border: 2px solid #e2e8f0;
  border-radius: 16px;
  font-size: 16px;
  background: #ffffff;
  color: #0f2b46;
  transition: all 0.3s ease;
  box-sizing: border-box;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  box-shadow: var(--shadow-sm);
}

.custom-swal-input:focus {
  outline: none;
  border-color: #0f2b46;
  box-shadow:
    0 0 0 4px rgba(6, 49, 100, 0.1),
    0 4px 16px rgba(6, 49, 100, 0.1);
  background: #ffffff;
  transform: translateY(-1px);
}

.custom-swal-input::placeholder {
  color: #94a3b8;
  font-weight: 400;
}

.custom-swal-actions {
  display: flex;
  gap: 16px;
  justify-content: center;
}

.custom-swal-button {
  padding: 14px 28px;
  border-radius: 16px;
  font-size: 16px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Poppins", sans-serif;
  min-width: 120px;
  position: relative;
  overflow: hidden;
}

.custom-swal-button::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.custom-swal-button:hover::before {
  left: 100%;
}

.custom-swal-button.cancel-button {
  /* background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%); */
  color: #64748b;
  box-shadow: var(--shadow-md);
  border: 1px solid #e2e8f0;
}

.custom-swal-button.cancel-button:hover {
  background: linear-gradient(135deg, #e2e8f0 0%, #cbd5e1 100%);
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
  color: #475569;
}

.custom-swal-button.confirm-button {
  /* background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%); */
  color: white;
  box-shadow: var(--shadow-lg);
  /* border: 1px solid #dc2626; */
}

.custom-swal-button.confirm-button:hover:not(:disabled) {
  /* background: linear-gradient(135deg, #b91c1c 0%, #991b1b 100%); */
  transform: translateY(-2px);
  box-shadow: var(--shadow-xl);
}

.custom-swal-button.confirm-button:disabled {
  /* background: linear-gradient(135deg, #fca5a5 0%, #f87171 100%); */
  color: #fecaca;
  cursor: not-allowed;
  transform: none;
  box-shadow: var(--shadow-sm);
  border-color: #fca5a5;
}

.custom-swal-button.confirm-button.donor-mode {
  background: #68b2cb;
  box-shadow: var(--shadow-lg);
  border-color: #68b2cb;
}

.custom-swal-button.confirm-button.donor-mode:hover:not(:disabled) {
  background: #68b2cb;
  box-shadow: var(--shadow-xl);
}

.custom-swal-button.confirm-button.orange-mode {
  /* background: linear-gradient(135deg, var(--amber) 0%, #d97706 100%); */
  box-shadow: var(--shadow-lg);
  border-color: var(--amber);
}


.custom-swal-button.confirm-button.orange-mode:hover:not(:disabled) {
  background: linear-gradient(135deg, #d97706 0%, #b45309 100%);
  box-shadow: var(--shadow-xl);
}

/* Enhanced Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-30px) scale(0.9);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes slideOut {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }

  to {
    opacity: 0;
    transform: translateY(30px) scale(0.9);
  }
}

/* Closing animations */
.custom-swal-overlay.closing {
  animation: fadeOut 0.2s ease-in forwards;
}

.custom-swal-modal.closing {
  animation: slideOut 0.2s ease-in forwards;
}

/* Pulse animation for warning icon */
.custom-swal-icon.warning-icon {
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow:
      0 12px 32px rgba(212, 148, 58, 0.25),
      0 0 0 1px rgba(212, 148, 58, 0.1) inset;
  }

  50% {
    box-shadow:
      0 12px 32px rgba(212, 148, 58, 0.35),
      0 0 0 1px rgba(212, 148, 58, 0.2) inset;
  }

  100% {
    box-shadow:
      0 12px 32px rgba(212, 148, 58, 0.25),
      0 0 0 1px rgba(212, 148, 58, 0.1) inset;
  }
}

/* Ensure modal is always fully visible */
.custom-swal-modal {
  position: relative !important;
  z-index: 100000 !important;
  transform: none !important;
}

/* Responsive design */
@media (max-width: 480px) {
  .custom-swal-modal {
    padding: 28px;
    margin: 16px;
    border-radius: 20px;
  }

  .custom-swal-title {
    font-size: 24px;
  }

  .custom-swal-text {
    font-size: 15px;
  }

  .custom-swal-actions {
    flex-direction: column;
    gap: 12px;
  }

  .custom-swal-button {
    width: 100%;
    padding: 16px 24px;
  }

  .custom-swal-icon {
    width: 64px;
    height: 64px;
    font-size: 32px;
  }
}

/* Company admin dark (body.admin-dark-active from Admin.jsx) */
body.admin-dark-active .custom-swal-modal {
  background: linear-gradient(145deg, #1a2332 0%, #151d2a 100%);
  border: 2px solid #2d3b4e;
  box-shadow:
    0 25px 80px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(255, 255, 255, 0.06) inset;
}

body.admin-dark-active .custom-swal-title {
  color: #e8eaed;
}

body.admin-dark-active .custom-swal-text {
  color: #9aa0a6;
}

body.admin-dark-active .custom-swal-input {
  background: #151d2a !important;
  color: #e8eaed !important;
  border-color: #2d3b4e !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

body.admin-dark-active .custom-swal-input:focus {
  border-color: #60a5fa !important;
  background: #1a2332 !important;
  box-shadow: 0 0 0 4px rgba(96, 165, 250, 0.2);
}

body.admin-dark-active .custom-swal-input::placeholder {
  color: #9aa0a6;
}

body.admin-dark-active .custom-swal-button.cancel-button {
  background: #252f3f !important;
  color: #e8eaed !important;
  border: 1px solid #3d4f66 !important;
  box-shadow: none;
}

body.admin-dark-active .custom-swal-button.cancel-button:hover {
  background: #2d3b4e !important;
  color: #f8fafc !important;
}